"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTracking;

var _react = _interopRequireWildcard(require("react"));

var _ReactTrackingContext = _interopRequireDefault(require("./ReactTrackingContext"));

var _useTrackingImpl = _interopRequireDefault(require("./useTrackingImpl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useTracking(trackingData, options) {
  var contextValue = (0, _useTrackingImpl["default"])(trackingData, options);
  var Track = (0, _react.useCallback)(function (_ref) {
    var children = _ref.children;
    return _react["default"].createElement(_ReactTrackingContext["default"].Provider, {
      value: contextValue
    }, children);
  }, [contextValue]);
  return (0, _react.useMemo)(function () {
    return {
      Track: Track,
      getTrackingData: contextValue.tracking.getTrackingData,
      trackEvent: contextValue.tracking.dispatch
    };
  }, [contextValue, Track]);
}